import { GoogleIcon } from '@/components/icons/common'
import { Button } from '@/components/ui/button'

import { useOauth } from '@/lib/hooks/use-oauth'

export function GoogleButton({
  referralCode,
  type,
}: {
  referralCode?: string
  type: 'login' | 'register'
}) {
  const url = useOauth(referralCode)

  return (
    <Button
      variant="outline"
      className="w-full rounded-xl"
      type="button"
      asChild
    >
      <a href={url}>
        <GoogleIcon />
        <span className="ml-2">
          {type === 'login' ? 'Login' : 'Daftar'} dengan Google
        </span>
      </a>
    </Button>
  )
}
